var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forecast-icon"},[_c('img',{attrs:{"src":_vm.weatherIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }